import { LOGIN_URL, RESET_PASSWORD, CONFIRM_EMAIL } from "config/api";
import { BaseService } from "./BaseService";
import {
  IOSLogInRequest,
  resetPasswordRequest,
  confirmEmailRequest,
} from "models/signIn";

class SignInService extends BaseService {
  public async logIn(data: IOSLogInRequest): Promise<any> {
    return this.post(LOGIN_URL, data);
  }
  public async resetPassword(data: resetPasswordRequest): Promise<any> {
    return this.post(RESET_PASSWORD, data);
  }
  public async confirmEmail(data: confirmEmailRequest): Promise<any> {
    return this.post(CONFIRM_EMAIL, data);
  }
}

export const signInService = new SignInService();
